/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import Plot from "react-plotly.js";

export default function NetPositionChart({

    latestData = []

}) {

    if (!latestData.length) {

        return (

            <div
                className="
                    bg-slate-950
                    border
                    border-slate-800
                    rounded-3xl
                    p-6
                    text-slate-400
                "
            >
                No positioning data available.
            </div>

        );

    }

    const sortedData = [...latestData]

        .sort(
            (a, b) =>
                Math.abs(b.net_oi) -
                Math.abs(a.net_oi)
        );

    const clients = sortedData.map(
        d => d.client
    );

    const netPositions =
        sortedData.map(
            d => d.net_oi
        );

    const colors =
        netPositions.map(v =>

            v >= 0
                ? "#10b981"
                : "#ef4444"

        );

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            "
        >

            <div
                className="
                    mb-4
                "
            >

                <h2
                    className="
                        text-xl
                        font-semibold
                        text-white
                    "
                >
                    Net Futures Positioning
                </h2>

                <p
                    className="
                        text-sm
                        text-slate-400
                    "
                >
                    Long OI − Short OI by participant category
                </p>

            </div>

            <Plot

                data={[

                    {

                        x: netPositions,

                        y: clients,

                        type: "bar",

                        orientation: "h",

                        text:
                            netPositions.map(

                                v =>
                                    Intl.NumberFormat(
                                        "en-IN"
                                    ).format(
                                        Math.round(v)
                                    )

                            ),

                        textposition:
                            "auto",

                        marker: {
                            color: colors
                        }

                    }

                ]}

                layout={{

                    height: 450,

                    paper_bgcolor:
                        "#020617",

                    plot_bgcolor:
                        "#020617",

                    font: {
                        color:
                            "#cbd5e1"
                    },

                    margin: {
                        l: 120,
                        r: 40,
                        t: 20,
                        b: 50
                    },

                    xaxis: {

                        title:
                            "Net OI",

                        zeroline: true,

                        zerolinewidth: 2,

                        zerolinecolor:
                            "#94a3b8",

                        gridcolor:
                            "#1e293b"

                    },

                    yaxis: {

                        automargin: true

                    },

                    showlegend: false

                }}

                config={{

                    responsive: true,

                    displayModeBar: false

                }}

                style={{
                    width: "100%"
                }}

            />

            <div
                className="
                    mt-3
                    text-xs
                    text-slate-500
                "
            >
                Green = Net Long • Red = Net Short
            </div>

        </div>

    );

}